import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/actl_logo.gif";

const FOOTER_COLS = [
  {
    heading: "Solutions",
    links: [
      { label: "IT Consulting Services", href: "/it-consulting-services" },
      { label: "Managed Services", href: "/services/managed-services" },
      { label: "Dedicated Engineering Teams", href: "/services/dedicated-engineering-teams" },
      { label: "Legacy Modernization", href: "/services/legacy-modernization" },
      { label: "Enterprise AI Enablement", href: "/services/enterprise-ai-enablement" },
      { label: "Quality Assurance", href: "/quality-assurance" },
      { label: "Mobile App Development", href: "/quality-assurance" },
    ],
  },
  {
    heading: "Industry Verticals",
    links: [
      { label: "Travel & Hospitality", href: "/travel-hospitality" },
      { label: "Healthcare", href: "/healthcare" },
      { label: "Insurance", href: "/insurance" },
      { label: "Legal", href: "/legal" },
    ],
  },
  {
    heading: "Enterprise AI",
    links: [
      { label: "Enterprise AI Enablement", href: "/services/enterprise-ai-enablement" },
      { label: "Forward Deployed Engineers", href: "/services/dedicated-engineering-teams" },
      { label: "Enterprise AI for Travel", href: "/travel-hospitality" },
      { label: "Enterprise AI for Healthcare", href: "/healthcare" },
      { label: "Enterprise AI for Insurance", href: "/insurance" },
      { label: "Enterprise AI for Legal", href: "/legal" },
    ],
  },
  {
    heading: "Services",
    links: [
      { label: "Design Suite", href: "/design-suite" },
      { label: "Microsoft Technologies", href: "/microsoft-technologies" },
      { label: "DotNetNuke Development", href: "/dotnetnuke-development" },
      { label: "Java Development", href: "/java-development" },
      { label: "Project Management", href: "/project-management" },
      { label: "IT Consulting", href: "/it-consulting-services" },
      { label: "Quality Assurance", href: "/quality-assurance" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Insights / Blog", href: "/resources/insights" },
      { label: "News & Press Release", href: "/news" },
      { label: "Events", href: "/events" },
      { label: "Membership", href: "/membership" },
      { label: "International Projects", href: "/international-projects" },
      { label: "Domestic Projects", href: "/domestic-projects" },
      { label: "International Acceptance", href: "/international-acceptance" },
    ],
  },
  {
    heading: "About Us",
    links: [
      { label: "About Avani Cimcon", href: "/about" },
      { label: "Management", href: "/management" },
      { label: "Expertise & Experience", href: "/expertise-experience" },
      { label: "ACT Advantage", href: "/advantage" },
      { label: "Value Proposition", href: "/value-proposition" },
      { label: "Partners – Objective", href: "/objective" },
      { label: "Partners – Benefits", href: "/benefits" },
      { label: "Partners Program", href: "/partners-program" },
      { label: "Careers", href: "/careers" },
      { label: "Contact Us", href: "/contact-us" },
    ],
  },
  {
    heading: "Products",
    links: [
      { label: "DXchange", href: "/dxchange" },
      { label: "BizRuleEngine", href: "/biz-rule-engine" },
      { label: "CMS", href: "/cms" },
      { label: "CARMA", href: "/carma" },
      { label: "Online Examination", href: "/online-examination" },
      { label: "Umrah Booking Solution", href: "/umrah-booking-solution" },
      { label: "More Products", href: "/more-products" },
    ],
  },
];

const ChevronDown = () => (
  <svg className="footer-v2-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M19 9l-7 7-7-7" />
  </svg>
);

const NewFooter = () => {
  const [openCol, setOpenCol] = useState(null);

  const toggle = (heading) => {
    setOpenCol(openCol === heading ? null : heading);
  };

  return (
    <footer className="footer-v2" aria-label="Site footer">
      <div className="container">
        <div className="row">
          {/* Brand column */}
          <div className="col-lg-2 mb-4">
            <Link to="/" aria-label="Avani Cimcon Technologies — Home">
              <img
                src={Logo}
                alt="Avani Cimcon Technologies"
                style={{ height: "40px", filter: "brightness(0) invert(1)", marginBottom: "12px" }}
              />
            </Link>
            <p className="footer-v2-tagline">
              Delivering cutting-edge software solutions since 1992.
              Tech consulting. Proven execution.
              Research-driven. Results that last.
            </p>
          </div>

          {/* Nav columns */}
          {FOOTER_COLS.map((col) => (
            <div key={col.heading} className="col-lg-1-7 col-md-4 col-6 mb-4" style={{ flex: "0 0 auto", width: "calc(100% / 7 - 10px)", minWidth: "130px" }}>
              <button
                className="footer-v2-col-toggle"
                onClick={() => toggle(col.heading)}
                aria-expanded={openCol === col.heading}
              >
                <h4>{col.heading}</h4>
                <ChevronDown />
              </button>
              <ul className={openCol === col.heading ? "is-open" : ""}>
                {col.links.map((link) => (
                  <li key={link.href + link.label}>
                    <Link to={link.href}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact row */}
        <div className="row mt-3" style={{ borderTop: "1px solid rgba(255,255,255,.08)", paddingTop: "24px", marginBottom: "0" }}>
          <div className="col-md-6">
            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
              <a href="tel:+91792687217" style={{ fontSize: "12px", color: "rgba(255,255,255,.5)", textDecoration: "none" }}>
                +91 79 2687 2171
              </a>
              <a href="tel:+16094039000" style={{ fontSize: "12px", color: "rgba(255,255,255,.5)", textDecoration: "none" }}>
                +1 (609) 403-9000
              </a>
              <a href="mailto:inquiry@avanicimcon.com" style={{ fontSize: "12px", color: "rgba(255,255,255,.5)", textDecoration: "none" }}>
                inquiry@avanicimcon.com
              </a>
            </div>
          </div>
          <div className="col-md-6 text-md-right mt-2 mt-md-0">
            <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", justifyContent: "flex-end", alignItems: "center" }}>
              <Link to="/contact-us" style={{ fontSize: "11px", color: "rgba(255,255,255,.3)" }}>Talk to Us</Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-v2-bottom d-flex flex-wrap justify-content-between align-items-center">
          <p>© {new Date().getFullYear()} Avani Cimcon Technologies. All rights reserved.</p>
          <div className="footer-v2-iso">
            <svg width="12" height="12" fill="#22c55e" viewBox="0 0 20 20" aria-hidden="true">
              <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            ISO 9001:2015 Certified
          </div>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
